import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { API_KEY, IDLE_SESSION_TIMEOUT, sentryErrorLog } from '../../Constants/AppConstants';
import PropTypes from "prop-types";
import classnames from 'classnames';
import validateLogin from '../../Validations/Login';
import AlertWrapper from '../Common/AlertWrapper';
import history from '../../history';
import FlashMessagesList from '../FlashMessages/FlashMessagesList';
import { connect } from 'react-redux';
import { userLoginRequest } from '../../Store/actions/loginActions';
import { logout } from '../../Store/actions/loginActions';

class LoginForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            api_key: API_KEY,
            user_login: '',
            password: '',
            remember: '',
            errors: {},
            isValid: false,
            isLoading: false,
            isFormValid: true,
            server_message: ''
        }
    }

    changeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    changeRememberHandler = (e) => {
        if (document.getElementById("remember").checked) {
            this.setState({
                remember: 'checked'
            });
        } else {
            this.setState({
                remember: ''
            });
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        const val_return = validateLogin(this.state);
        this.setState(val_return);
        if (val_return.isValid) {
            this.setState({ errors: {}, isLoading: true });
            this.props.userLoginRequest(this.state).then(results => {

                // Sentry Log create
                sentryErrorLog(results);

                if (results.response.code === 1000) {
                    //set localStorage
                    if (results.response.data.assigned_contact_id !== 0 && results.response.data.assigned_gym_owner_id !== 0) {
                        localStorage.setItem("autoAssignInfo", JSON.stringify({
                            'assignedContactID': results.response.data.assigned_contact_id,
                            'assignedContactName': '',
                            'assignedGymOwnerID': results.response.data.assigned_gym_owner_id,
                            'assignedGymOwnerName': '',
                        }))
                    }

                    history.push('/');
                    setTimeout(() => {
                        localStorage.setItem("idleTimeLeft", IDLE_SESSION_TIMEOUT);
                    }, 2000)
                } else {
                    this.setState({
                        server_message: results.response.message,
                        isLoading: false,
                        isFormValid: false
                    });
                }
            }
            );
        }
    }

    render() {
        const { errors, server_message } = this.state;
        const errors_data = server_message;
        return (
            <div className="login-form">
                <AlertWrapper errors_data={errors_data} isFormValid={this.state.isFormValid} />
                <FlashMessagesList />
                <form className="action_form" onSubmit={this.onSubmit} method="post">
                    <div className="form-group">
                        <label className={classnames(null, { 'pl_error_label': errors.user_login })} htmlFor="user_login">Username or email address <span className="required">*</span></label>
                        <input type="text" className={classnames("cus_field", { 'pl_error_input': errors.user_login })} name="user_login" id="user_login" value={this.state.user_login} onChange={this.changeHandler} />

                    </div>
                    <div className="form-group">
                        <label className={classnames(null, { 'pl_error_label': errors.password })} htmlFor="password">Password <span className="required">*</span></label>
                        <input className={classnames("cus_field", { 'pl_error_input': errors.password })} type="password" name="password" id="password" value={this.state.password} onChange={this.changeHandler} />
                    </div>
                    <div className="form-group btn-with-check-pws">
                        <button type="submit" disabled={this.state.isLoading} className="cus_button" name="login" value="Login">{this.state.isLoading ? 'Please Wait...' : 'Login'}</button>

                        <div className="inline_checkbox custom-control custom-checkbox">
                            <input onChange={this.changeRememberHandler} type="checkbox" className={classnames('custom-control-input', { 'pl_error_checkbox': errors.remember })} id="remember" name="remember" />
                            <label className="custom-control-label" htmlFor="remember">Remember me</label>
                        </div>

                        <div className="clearfix"></div>
                    </div>
                    <div className="lost_password">
                        <NavLink activeClassName='active' to="/password-reset"> Lost your password?</NavLink>
                    </div>
                </form>
            </div>
        );
    }
}

LoginForm.propTypes = {
    userLoginRequest: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, { userLoginRequest, logout })(LoginForm);